// When a client clicks on the Rolex menu button, toggle between showing & hiding the dropdown menu
function toggleRolexMenu() 
{
    const breadCrumbs = document.getElementById('rolexBreadcrumbs');
    const navLinkContainer = document.getElementById('rolexNavigationLinks');
	const navLinks = document.querySelectorAll('#rolexNavigationLinks a');
  
	if (navLinkContainer.style.maxHeight == '1300px') 
	{
		navLinkContainer.style.maxHeight = 0; 
		navLinkContainer.style.opacity = 0;
		navLinkContainer.style.top = '-25px';
        navLinkContainer.style.opacity = 0;
        
		animateToggleArrowDown();

        if (breadCrumbs != null) { breadCrumbs.removeAttribute('style'); }

		navLinks.forEach(link => { link.tabIndex = -1; });
	}
	else
	{
		navLinkContainer.style.maxHeight = '1300px'; 
		navLinkContainer.style.opacity = 1;
		navLinkContainer.style.top = 0;
		
		// add the width here to safeguard against undesired layouts when initially hidden in some browsers
		navLinkContainer.style.width = '100vw'; 
		
		// add transition here to safeguard against the fade-in of links not rendering in some browsers
		navLinkContainer.style.transition = 'max-height 0.4s ease-in-out, opacity 0.7s ease-in-out, top 0.4s ease-in-out'; 
		
		animateToggleArrowUp();

        if (breadCrumbs != null) 
        {
            document.getElementById('rolexBreadcrumbs').style.opacity = 0;
            document.getElementById('rolexBreadcrumbs').style.maxHeight = 0;
        }

		navLinks.forEach(link => { link.tabIndex = 0; });
	}

	console.log("Menu toggled");
}

// Hide the menu if the client clicks anywhere outside of the menu when it's open
window.addEventListener('click', function(event)
{   
    const breadCrumbs = document.getElementById('rolexBreadcrumbs');
    const navLinkContainer = document.getElementById('rolexNavigationLinks');
	const navLinks = document.querySelectorAll('#rolexNavigationLinks a');
    const navBar = document.getElementById('rolexNavigationBar');
  
	if (!navBar.contains(event.target) && navLinkContainer.style.maxHeight == '1300px')
  	{
		navLinkContainer.style.maxHeight = 0; 
        if (breadCrumbs != null) { breadCrumbs.removeAttribute('style'); }
		navLinks.forEach(link => { link.tabIndex = -1; });
	} 
});

// Clear inline styles if the desktop browser window is resized
function viewportWasResized() 
{
	const breadCrumbs = document.getElementById('rolexBreadcrumbs');

	if (window.innerWidth > 1024) {
    	if (breadCrumbs != null) { breadCrumbs.removeAttribute('style'); }
		document.getElementById('rolexNavigationLinks').removeAttribute('style');
    	document.getElementById('rolexMenuToggleArrow').removeAttribute('style');   
	}
}
window.onresize = viewportWasResized;

// Determine whether we're displaying a navigation bar or a dropdown navigation menu
// Toggle the keyboard navigation for menu items accordingly
function verifyMenuMode() 
{
	const menuToggle = document.getElementsByClassName('rolex-mobile-menu-toggle');
  	const isBar = window.getComputedStyle(menuToggle[0]).display === 'none';
  	const navLinks = document.querySelectorAll('#rolexNavigationLinks a');
	navLinks.forEach(link => { link.tabIndex = isBar ? 0 : -1; });
}

// Rotate animations for menu toggle arrow
// (to workaround CSS animations stacking asynchronously in some browsers)
function animateToggleArrowUp() 
{
	let id = null;
	const arrow = document.getElementById('rolexMenuToggleArrow');   
	let degrees = 0;
	clearInterval(id);
	id = setInterval(frame, 0.1);
	function frame() 
	{
		if (degrees == 180) 
		{
			clearInterval(id);
		} 
		else 
		{
			degrees+=3; 
			yPos = degrees/270 + 1/180; // nudge the position to visually balance the arrow better
			arrow.style.transform = 'translate(0,' + yPos + 'px) rotate(' + degrees + 'deg)'; 
		}
	}
}

function animateToggleArrowDown() 
{
	let id = null;
	const arrow = document.getElementById('rolexMenuToggleArrow');   
	let degrees = 180;
	clearInterval(id);
	id = setInterval(frame, 0.15);
	function frame() 
	{
		if (degrees == 0) 
		{
			clearInterval(id);
		} else 
		{
			degrees-=4; 
			yPos = degrees/270;
			arrow.style.transform = 'translate(0,' + yPos + 'px) rotate(' + degrees + 'deg)'; 
		}
	}
}

// For optimal keyboard navigation, run a quick verification of the menu once the page loads
verifyMenuMode(); 

// Arrow Navigation
const listContainer = document.getElementById('rolexNavigationLinks');
listContainer.addEventListener('keydown', (event) => 
{ 
	const links = Array.from(listContainer.querySelectorAll('a'));
	const currentIndex = links.indexOf(document.activeElement); // Determine which menu item, if any, currently has focus
	if (currentIndex === -1) return; // If the focus isn't on a link inside the Rolex menu, do nothing
	const menuToggle = document.getElementsByClassName('rolex-mobile-menu-toggle');
	const isBar = window.getComputedStyle(menuToggle[0]).display === 'none'; 
	let nextIndex; // Initialize outside of scope to allow for looping over menu items with the arrow keys

	if (event.key === 'ArrowDown' && !isBar) 
	{
		event.preventDefault(); // Prevent page scrolling
		nextIndex = (currentIndex + 1) % links.length;
		links[nextIndex].focus();
	} 
	else if (event.key === 'ArrowUp' && !isBar) 
	{
		event.preventDefault(); // Prevent page scrolling
		nextIndex = (currentIndex - 1 + links.length) % links.length;
		links[nextIndex].focus();
	}
	else if (event.key === 'ArrowRight' && isBar) 
	{
		event.preventDefault(); // Prevent page scrolling
		nextIndex = (currentIndex + 1) % links.length;
		links[nextIndex].focus();
	} 
	else if (event.key === 'ArrowLeft' && isBar) 
	{
		event.preventDefault(); // Prevent page scrolling
		nextIndex = (currentIndex - 1 + links.length) % links.length;
		links[nextIndex].focus();
	}
});